// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__zByqY","primary":"Button_primary__lKTj6","secondary":"Button_secondary__z2bYv","swing-in":"Button_swing-in__5EpaB"};